export interface EqualizerBand {
  frequency: number;
  gain: number;
  label: string;
}

export interface EqualizerPreset {
  id: string;
  name: string;
  bands: EqualizerBand[];
  isCustom: boolean;
  isActive: boolean;
}

export const DEFAULT_EQ_BANDS: EqualizerBand[] = [
  { frequency: 60, gain: 0, label: '60 Hz' },
  { frequency: 250, gain: 0, label: '250 Hz' },
  { frequency: 1000, gain: 0, label: '1 kHz' },
  { frequency: 4000, gain: 0, label: '4 kHz' },
  { frequency: 16000, gain: 0, label: '16 kHz' }
];

export const PRESET_LIBRARY: EqualizerPreset[] = [
  {
    id: 'normal',
    name: 'Normal',
    bands: DEFAULT_EQ_BANDS.map(b => ({ ...b })),
    isCustom: false,
    isActive: true
  },
  {
    id: 'bass-boost',
    name: 'Bass Boost',
    bands: [
      { frequency: 60, gain: 8, label: '60 Hz' },
      { frequency: 250, gain: 5, label: '250 Hz' },
      { frequency: 1000, gain: 0, label: '1 kHz' },
      { frequency: 4000, gain: -2, label: '4 kHz' },
      { frequency: 16000, gain: -3, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'treble-boost',
    name: 'Treble Boost',
    bands: [
      { frequency: 60, gain: -3, label: '60 Hz' },
      { frequency: 250, gain: -1, label: '250 Hz' },
      { frequency: 1000, gain: 2, label: '1 kHz' },
      { frequency: 4000, gain: 6, label: '4 kHz' },
      { frequency: 16000, gain: 8, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'vocal-boost',
    name: 'Vocal Boost',
    bands: [
      { frequency: 60, gain: -2, label: '60 Hz' },
      { frequency: 250, gain: 2, label: '250 Hz' },
      { frequency: 1000, gain: 5, label: '1 kHz' },
      { frequency: 4000, gain: 4, label: '4 kHz' },
      { frequency: 16000, gain: 1, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'pop',
    name: 'Pop',
    bands: [
      { frequency: 60, gain: 4, label: '60 Hz' },
      { frequency: 250, gain: 1, label: '250 Hz' },
      { frequency: 1000, gain: -2, label: '1 kHz' },
      { frequency: 4000, gain: 3, label: '4 kHz' },
      { frequency: 16000, gain: 5, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'rock',
    name: 'Rock',
    bands: [
      { frequency: 60, gain: 8, label: '60 Hz' },
      { frequency: 250, gain: 4, label: '250 Hz' },
      { frequency: 1000, gain: -3, label: '1 kHz' },
      { frequency: 4000, gain: 2, label: '4 kHz' },
      { frequency: 16000, gain: 6, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'jazz',
    name: 'Jazz',
    bands: [
      { frequency: 60, gain: 5, label: '60 Hz' },
      { frequency: 250, gain: 2, label: '250 Hz' },
      { frequency: 1000, gain: 1, label: '1 kHz' },
      { frequency: 4000, gain: 3, label: '4 kHz' },
      { frequency: 16000, gain: 4, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'classical',
    name: 'Classical',
    bands: [
      { frequency: 60, gain: 2, label: '60 Hz' },
      { frequency: 250, gain: 1, label: '250 Hz' },
      { frequency: 1000, gain: -1, label: '1 kHz' },
      { frequency: 4000, gain: 2, label: '4 kHz' },
      { frequency: 16000, gain: 3, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  },
  {
    id: 'electronic',
    name: 'Electronic',
    bands: [
      { frequency: 60, gain: 6, label: '60 Hz' },
      { frequency: 250, gain: 3, label: '250 Hz' },
      { frequency: 1000, gain: 1, label: '1 kHz' },
      { frequency: 4000, gain: 5, label: '4 kHz' },
      { frequency: 16000, gain: 7, label: '16 kHz' }
    ],
    isCustom: false,
    isActive: false
  }
];
